import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-github",
  "use": "icon-github-usage",
  "viewBox": "0 0 32 32",
  "content": "<symbol viewBox=\"0 0 32 32\" id=\"icon-github\"><path d=\"M15.999 0c-8.835 0-16 7.115-16 15.894 0 7.02 4.585 12.976 10.943 15.079.8.145 1.092-.346 1.092-.767 0-.377-.013-1.377-.021-2.702-4.45.96-5.39-2.131-5.39-2.131-.727-1.836-1.776-2.324-1.776-2.324-1.453-.986.11-.967.11-.967 1.606.113 2.45 1.638 2.45 1.638 1.427 2.428 3.744 1.727 4.657 1.321.145-1.027.558-1.728 1.016-2.125-3.553-.4-7.288-1.765-7.288-7.854 0-1.735.623-3.154 1.647-4.265-.165-.402-.714-2.017.156-4.206 0 0 1.344-.427 4.4 1.63a15.422 15.422 0 0 1 4.006-.536c1.358.007 2.727.182 4.005.536 3.055-2.057 4.395-1.63 4.395-1.63.874 2.189.324 3.804.16 4.206 1.025 1.111 1.645 2.53 1.645 4.265 0 6.105-3.742 7.448-7.306 7.842.575.49 1.086 1.46 1.086 2.943 0 2.124-.02 3.838-.02 4.359 0 .425.288.92 1.1.765C27.42 28.865 32 22.912 32 15.894 32 7.115 24.835 0 15.999 0\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./app/icons/icon-github.svg
// module id = 874
// module chunks = 74